import { render, staticRenderFns } from "./aliBey.vue?vue&type=template&id=75a1e5d0&scoped=true"
import script from "./aliBey.vue?vue&type=script&lang=js"
export * from "./aliBey.vue?vue&type=script&lang=js"
import style0 from "./aliBey.vue?vue&type=style&index=0&id=75a1e5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75a1e5d0",
  null
  
)

export default component.exports